import Requester from "./Requester";

interface CreateDTO {
    clientId: number
    amount: number
    currency: string
}

export function getProducts(limit: number = 10, page: number = 1, filters: any, options) {
    const requester = new Requester();

    const prepareFilters: Array<any> = [];

    Object.keys(filters).forEach((key) => {
        const value = filters[key];

        prepareFilters.push({
            name: key,
            value,
        });
    })

    return requester.get(requester.getUrl('api/products', [
        ...prepareFilters,
        { name: 'limit', value: limit },
        { name: 'page', value: page },
    ]), {
        signal: options.signal
    })
}

export function getProductsByStore(limit: number = 10, page: number = 1, search: string | null = null, options) {
    const requester = new Requester();

    return requester.get(requester.getUrl('api/products-by-store', [
        { name: 'limit', value: limit },
        { name: 'page', value: page },
        { name: 'search', value: search },
    ]), {
        signal: options.signal
    })
}

export function merge(secondaryId: number, mainId: number, options) {
    const requester = new Requester();

    return requester.post(requester.getUrl(`api/products/${secondaryId}/merge/${mainId}`), [], {
        signal: options.signal
    })
}

export function getProduct(id: number) {
    const requester = new Requester();

    return requester.get(requester.getUrl(`api/products/${id}`))
}

export function updateAttributes(id: number, values) {
    const requester = new Requester();

    return requester.post(requester.getUrl(`api/products/${id}/attributes`), values)
}

export function destroy(id) {
    const requester = new Requester();

    return requester.delete(requester.getUrl(`api/products/${id}`))
}

export function create(values: CreateDTO) {
    const requester = new Requester();

    return requester.post(requester.getUrl(`api/products`), values)
}

export default {
    create,
    getProducts,
    getProduct,
    destroy,
    merge,
}